<template>
  <div class="header-nav">
    <div class="wrap">
      <h2>{{ agencyname }}</h2>
      <ul class="nav">
        <li><a @click.prevent="logout()" href="#">Wavve on 나가기</a></li>
<!--        <li class="li-none">-->
<!--          <a @click.prevent="moveToSchedule()" href="#" class="a-none">편성표</a>-->
<!--        </li>-->
      </ul>
    </div>
  </div>
</template>

<script>
import cookie from '@/common/utils/cookie'
import constant from '@/common/resources/constant'
import { PATH_NAME_SCHEDULE } from '@/common/resources/router.const'

export default {
  name: 'util-menu',
  props: {
    agencyname: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      showLoginPop: false
    }
  },
  methods: {
    logout () {
      cookie.removeItems({ keyList: ['pzInfo', 'cs', 'pz', 'SHARE_KEY'] })
      cookie.setItem('pz', JSON.stringify({ isPooqzone: false }), false, constant.URL_COOKIE_DOMAIN, '/')
      localStorage.clear()
      location.href = '/'
    },
    moveToSchedule () {
      this.$router.push({ name: PATH_NAME_SCHEDULE })
    }
  }
}
</script>
